import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import MicrosoftAzureIntegration from "../MicrosoftAzure/MicrosoftAzure";

const MicrosoftDefenderEndpointIntegration = () => {
  const [searchParams] = useSearchParams();
  const [guideMode, setGuideMode] = useState(false);

  useEffect(() => {
    if (searchParams.has("viewonly")) {
      setGuideMode(true);
    }
  }, [searchParams]);
  return (
    <MicrosoftAzureIntegration
      integrationName="microsoft_defender_endpoint"
      guideMode={guideMode}
    ></MicrosoftAzureIntegration>
  );
};

export default MicrosoftDefenderEndpointIntegration;
